"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const cards_scss_1 = __importDefault(require("./styles/cards.scss"));
function Card({ elevated, children, className }) {
    return (React.createElement("div", { className: classnames_1.default(elevated ? cards_scss_1.default.elevated : cards_scss_1.default.outlined, className) }, children));
}
exports.Card = Card;
function CardDivider() {
    return React.createElement("div", { className: cards_scss_1.default.divider });
}
exports.CardDivider = CardDivider;
